/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import RevanueForYearlyChart from './RevenueForYearlyChart';

const RevenueShowForYearly = ({ dir, data, viewReportButton, title, selectedYear, month, currentlyShow }) => {
    const yearlyData = {};    

    data.forEach((item) => {   
        if (item && yearlyData[item.salesYear]) {
            yearlyData[item.salesYear].push(item)
        } else {
            yearlyData[item.salesYear] = [item]
        }
                   
    })

    const dataToPlot = []

    if(currentlyShow?.value === 'Won')
    {
        Object.keys((yearlyData)).forEach((year) => {
            const totalJan = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.jan), 0)
            const totalFeb = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.feb), 0)
            const totalMar = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.mar), 0)
            const totalApr = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.apr), 0)
            const totalMay = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.may), 0)
            const totalJun = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.jun), 0)
            const totalJul = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.jul), 0)
            const totalAug = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.aug), 0)
            const totalSep = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.sept), 0)
            const totalOct = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.oct), 0)
            const totalNov = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.nov), 0)
            const totalDec = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.dec), 0)

            const totalAmt = totalJan + totalFeb + totalMar + totalApr + totalMay
            + totalJun + totalJul + totalAug + totalSep + totalOct + totalNov + totalDec
        
            
            dataToPlot.push({
                "year": year,            
                'Amount': Number(totalAmt),            
            })    

        })   
    }
    else
    {
        Object.keys((yearlyData)).forEach((year) => {
            const totalJan = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.janDollarConverted), 0)
            const totalFeb = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.febDollarConverted), 0)
            const totalMar = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.marDollarConverted), 0)
            const totalApr = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.aprDollarConverted), 0)
            const totalMay = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.mayDollarConverted), 0)
            const totalJun = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.junDollarConverted), 0)
            const totalJul = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.julDollarConverted), 0)
            const totalAug = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.augDollarConverted), 0)
            const totalSep = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.septDollarConverted), 0)
            const totalOct = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.octDollarConverted), 0)
            const totalNov = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.novDollarConverted), 0)
            const totalDec = yearlyData?.[year]?.reduce((acc, item) => acc + Number(item.decDollarConverted), 0)

            const totalAmt = totalJan + totalFeb + totalMar + totalApr + totalMay
            + totalJun + totalJul + totalAug + totalSep + totalOct + totalNov + totalDec
        
            
            dataToPlot.push({
                "year": year,            
                'Amount': Number(totalAmt),            
            })    

        })   
    }
    
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                {/* <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-5">{title}</h5>
                    {viewReportButton?.()}
                </div> */}

                {data?.length ? (
                    <RevanueForYearlyChart
                        dataToPlot={dataToPlot}
                        height={400}
                        showTitle={false}
                        currency={currentlyShow?.value}
                        dir={dir}
                    />

                ) : 'No data to display'}
            </Card>
        </Col>

    )
}

RevenueShowForYearly.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    selectedYear: PropTypes.object.isRequired,
    month: PropTypes.object.isRequired,
    currentlyShow: PropTypes.object.isRequired
};

RevenueShowForYearly.defaultProps = {
    title: 'Revenue',
}

export default RevenueShowForYearly;
